import { removeLastFromQueue } from 'actions/notifications-actions'
import { useEffect, ReactNode } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { AppState } from 'redux/reducers'
import { InteractiveNotification } from 'types/global'

type RenderMessage<T = unknown> = (notification: InteractiveNotification<T>) => ReactNode

const notify = <T,>(notification: InteractiveNotification<T>, renderMessage: RenderMessage<T>) =>
  toast(renderMessage(notification), {
    type: notification.type,
  })

const useInteractiveNotitfications = <T,>(key: string, renderMessage: RenderMessage<T>) => {
  const dispatch = useDispatch()
  const queue = useSelector((state: AppState) => state.notifications[key].queue)
  const counter = useSelector((state: AppState) => state.notifications[key].counter)

  useEffect(() => {
    if (queue.length) {
      notify(queue[queue.length - 1], renderMessage)
      dispatch(removeLastFromQueue(key))
    }
  }, [queue, dispatch, counter, key, renderMessage])
}

export default useInteractiveNotitfications
